import { isFunction } from '../_';

export const safeScopedSlotMixin = {
  methods: {
    safeScopedSlot(name, args, def = null) {
      return isFunction(this.$slots[name])
        ? this.$slots[name](args)
        : def;
    },
  },
};
